module.exports = __webpack_public_path__ + "img/testimony.4f8552cf.png";